import {Component, Input} from '@angular/core';
import {FormGroup, FormGroupDirective} from "@angular/forms";
import {DynamicFormModel} from "../../models/dynamic-form-model";

@Component({
  selector: 'ebw-monorepo-dynamic-radio',
  templateUrl: './dynamic-radio.component.html',
  styleUrls: ['./dynamic-radio.component.scss']
})
export class DynamicRadioComponent {
  @Input() field: DynamicFormModel;
  formName: FormGroup;
  constructor(private formgroupDirective: FormGroupDirective) {
    this.formName = formgroupDirective.control;
  }
}
